import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '@core/services/feature-flag.service';
import { WorkspaceService } from '@core/services/workspace.service';
import { map } from 'rxjs';

/**
 * Blocks the marketplace routes when the product feature is disabled, so a deep
 * link doesn't land on a page the backend answers with "Marketplace is disabled"
 * (403). Mirrors the nav-item `feature` gate. Awaits the flag (cached) so the
 * decision is correct even on a cold deep-link before the shell has probed it.
 */
export const marketplaceFeatureGuard: CanActivateFn = () => {
  const features = inject(FeatureFlagService);
  const ws = inject(WorkspaceService);
  const router = inject(Router);

  return features
    .whenKnown('marketplace')
    .pipe(map((enabled) => enabled || router.createUrlTree([ws.homeRoute()])));
};
